module.exports = __webpack_public_path__ + "img/h-discord.7861fd39.svg";